var map = {
	"./abkhazia.png": "1f51",
	"./afghanistan.png": "eabf",
	"./aland-islands.png": "5a08",
	"./albania.png": "3c48",
	"./algeria.png": "dccc",
	"./american-samoa.png": "0246",
	"./andorra.png": "3d9c",
	"./angola.png": "ef40",
	"./anguilla.png": "55be",
	"./antigua-and-barbuda.png": "1d08",
	"./argentina.png": "dc6b",
	"./armenia.png": "0fa5",
	"./aruba.png": "73a2",
	"./australia.png": "ce47",
	"./austria.png": "0bbb",
	"./azerbaijan.png": "badc",
	"./azores-islands.png": "bf48",
	"./bahamas.png": "0bed",
	"./bahrain.png": "9e0f",
	"./balearic-islands.png": "6d45",
	"./bangladesh.png": "6417",
	"./barbados.png": "1e71",
	"./basque-country.png": "7014",
	"./belarus.png": "18c8",
	"./belgium.png": "d968",
	"./belize.png": "8ec0",
	"./benin.png": "8115",
	"./bermuda.png": "3220",
	"./bhutan-1.png": "ef71",
	"./bhutan.png": "fdcc",
	"./bolivia.png": "a9af",
	"./bonaire.png": "563c",
	"./bosnia-and-herzegovina.png": "7232",
	"./botswana.png": "6070",
	"./brazil.png": "3c54",
	"./british-columbia.png": "c7dd",
	"./british-indian-ocean-territory.png": "1120",
	"./british-virgin-islands.png": "a2d6",
	"./brunei.png": "156a",
	"./bulgaria.png": "0393",
	"./burkina-faso.png": "4dde",
	"./burundi.png": "7c76",
	"./cambodia.png": "39fa",
	"./cameroon.png": "b483",
	"./canada.png": "8bfa",
	"./canary-islands.png": "2615",
	"./cape-verde.png": "9a02",
	"./cayman-islands.png": "9e38",
	"./central-african-republic.png": "d25a",
	"./ceuta.png": "2e21",
	"./chad.png": "dfb7",
	"./chile.png": "cbf3",
	"./china.png": "0dfa",
	"./christmas-island.png": "9666",
	"./cocos-island.png": "fcf9",
	"./colombia.png": "332c",
	"./comoros.png": "336f",
	"./cook-islands.png": "3194",
	"./corsica.png": "80ca",
	"./costa-rica.png": "c8d3",
	"./croatia.png": "d557",
	"./cuba.png": "1ded",
	"./curacao.png": "e414",
	"./cyprus.png": "4987",
	"./czech-republic.png": "c692",
	"./democratic-republic-of-congo.png": "06ce",
	"./denmark.png": "184a",
	"./djibouti.png": "2046",
	"./dominica.png": "96f7",
	"./dominican-republic.png": "b586",
	"./east-timor.png": "b330",
	"./ecuador.png": "8917",
	"./egypt.png": "1311",
	"./england.png": "210f",
	"./equatorial-guinea.png": "418a",
	"./eritrea.png": "1ba7",
	"./estonia.png": "cc52",
	"./eswatini.png": "bdef",
	"./ethiopia.png": "eb7a",
	"./european-union.png": "a4fb",
	"./falkland-islands.png": "ce97",
	"./faroe-islands.png": "e538",
	"./fiji.png": "ef08",
	"./finland.png": "913d",
	"./france.png": "d16f",
	"./french-polynesia.png": "8ad9",
	"./gabon.png": "81d5",
	"./galapagos-islands.png": "d9fa",
	"./gambia.png": "519b",
	"./georgia.png": "b3e3",
	"./germany.png": "a1a3",
	"./ghana.png": "7e67",
	"./gibraltar.png": "694f",
	"./greece.png": "bc66",
	"./greenland.png": "4e91",
	"./grenada.png": "b788",
	"./guam.png": "49b9",
	"./guatemala.png": "6885",
	"./guernsey.png": "0c1c",
	"./guinea-bissau.png": "ed67",
	"./guinea.png": "54aa",
	"./guyana.png": "b060",
	"./haiti.png": "a325",
	"./hawaii.png": "69db",
	"./honduras.png": "7e11",
	"./hong-kong.png": "161b",
	"./hungary.png": "34ae",
	"./iceland.png": "fe3f",
	"./india.png": "a04c",
	"./indonesia.png": "7930",
	"./iran.png": "309c",
	"./iraq.png": "e03f",
	"./ireland.png": "ff5e",
	"./isle-of-man.png": "32db",
	"./israel.png": "f859",
	"./italy.png": "1288",
	"./ivory-coast.png": "c936",
	"./jamaica.png": "69af",
	"./japan.png": "e96e",
	"./jersey.png": "2213",
	"./jordan.png": "707b",
	"./kazakhstan.png": "1ee7",
	"./kenya.png": "9871",
	"./kiribati.png": "7851",
	"./kosovo.png": "0e22",
	"./kuwait.png": "20a7",
	"./kyrgyzstan.png": "7f207",
	"./laos.png": "b6e5",
	"./latvia.png": "26ac",
	"./lebanon.png": "4adb",
	"./lesotho.png": "6281",
	"./liberia.png": "21fd",
	"./libya.png": "d4f5",
	"./liechtenstein.png": "ffcc",
	"./lithuania.png": "bf2b",
	"./luxembourg.png": "0ebc",
	"./macao.png": "109b",
	"./madagascar.png": "a2b5",
	"./madeira.png": "eedc",
	"./malawi.png": "bd17",
	"./malaysia.png": "5051",
	"./maldives.png": "b724",
	"./mali.png": "f5f7",
	"./malta.png": "e58a",
	"./marshall-island.png": "6c16",
	"./martinique.png": "f4ad",
	"./mauritania.png": "f418",
	"./mauritius.png": "9088",
	"./melilla.png": "1958",
	"./mexico.png": "4c43",
	"./micronesia.png": "0ec9",
	"./moldova.png": "66ab",
	"./monaco.png": "6fce",
	"./mongolia.png": "c3c9",
	"./montenegro.png": "8efd",
	"./montserrat.png": "c366a",
	"./morocco.png": "9045",
	"./mozambique.png": "af0b",
	"./myanmar.png": "f37b",
	"./namibia.png": "1ac9",
	"./nato.png": "2b45",
	"./nauru.png": "34fa",
	"./nepal.png": "37dc",
	"./netherlands.png": "0c8f",
	"./new-zealand.png": "4324",
	"./nicaragua.png": "e54e",
	"./niger.png": "4d32",
	"./nigeria.png": "18f8",
	"./niue.png": "46e2",
	"./norfolk-island.png": "a7f6",
	"./north-korea.png": "0b67",
	"./northen-cyprus.png": "d794",
	"./northern-marianas-islands.png": "fbe5",
	"./norway.png": "dc46",
	"./oman.png": "45d9",
	"./orkney-islands.png": "77ed",
	"./ossetia.png": "bcb2",
	"./pakistan.png": "f85e",
	"./palau.png": "527b",
	"./palestine.png": "d8c6",
	"./panama.png": "4272",
	"./papua-new-guinea.png": "d5d2",
	"./paraguay.png": "6ace",
	"./peru.png": "242b1",
	"./philippines.png": "f50d",
	"./pitcairn-islands.png": "47a1",
	"./portugal.png": "5cad",
	"./puerto-rico.png": "70fe",
	"./qatar.png": "9c71",
	"./rapa-nui.png": "a0d3",
	"./republic-of-macedonia.png": "4f91",
	"./republic-of-poland.png": "380c",
	"./republic-of-the-congo.png": "d452",
	"./romania.png": "cf4f",
	"./russia.png": "0f1b",
	"./rwanda.png": "352a",
	"./saba-island.png": "1683",
	"./saint-kitts-and-nevis.png": "6df9",
	"./salvador.png": "1bfd",
	"./samoa.png": "fbaa",
	"./san-marino.png": "f4cc",
	"./sao-tome-and-principe.png": "e631",
	"./sardinia.png": "6d6a",
	"./saudi-arabia.png": "06f4",
	"./scotland.png": "91cc",
	"./senegal.png": "af00",
	"./serbia.png": "8eee",
	"./seychelles.png": "e961",
	"./sierra-leone.png": "1e1d",
	"./singapore.png": "2590",
	"./sint-eustatius.png": "0b7f",
	"./sint-maarten.png": "5bd6",
	"./slovakia.png": "047d",
	"./slovenia.png": "4af1",
	"./solomon-islands.png": "88f5",
	"./somalia.png": "2d9e",
	"./somaliland.png": "00c3",
	"./south-africa.png": "7675",
	"./south-korea.png": "3247",
	"./south-sudan.png": "fa5f",
	"./spain.png": "a5abf",
	"./sri-lanka.png": "0a7a",
	"./st-barts.png": "c858",
	"./st-lucia.png": "0f4f",
	"./st-vincent-and-the-grenadines.png": "9eff",
	"./sudan.png": "0385",
	"./suriname.png": "54d4",
	"./swaziland.png": "85f5",
	"./sweden.png": "3fbb",
	"./switzerland.png": "b7f2",
	"./syria.png": "bbbd",
	"./taiwan.png": "f632",
	"./tajikistan.png": "2c7e",
	"./tanzania.png": "d509",
	"./thailand.png": "93cd",
	"./tibet.png": "a443",
	"./togo.png": "7bba",
	"./tokelau.png": "f253",
	"./tonga.png": "130e",
	"./transnistria.png": "833c",
	"./trinidad-and-tobago.png": "9a63",
	"./tunisia.png": "6842",
	"./turkey.png": "e367",
	"./turkmenistan.png": "22b1",
	"./turks-and-caicos.png": "cfa5",
	"./tuvalu.png": "805d",
	"./uganda.png": "b0b7",
	"./ukraine.png": "eced",
	"./united-arab-emirates.png": "fa02",
	"./united-kingdom.png": "f9a8",
	"./united-nations.png": "b5a0",
	"./united-states-of-america.png": "f98d",
	"./uruguay.png": "b2b1",
	"./uzbekistn.png": "0293",
	"./vanuatu.png": "7d6c",
	"./vatican-city.png": "07a5",
	"./venezuela.png": "6012",
	"./vietnam.png": "466b",
	"./virgin-islands.png": "391e",
	"./wales.png": "1864",
	"./western-sahara.png": "82e0",
	"./yemen.png": "dd91",
	"./zambia.png": "9e03",
	"./zimbabwe.png": "1a1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e38";